import { AssignmentStatus } from '../../Assignment/enums/AssignmentStatus';
import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { API_FLEET_URL } from '@/utils';

export interface StatusCounterItem {
  status: AssignmentStatus;
  count: number;
}

const fleetDashboardService = createApi({
  reducerPath: 'fleetDashboardService',
  baseQuery: createBaseQueryWithReauth(`${API_FLEET_URL}/assignments`),

  tagTypes: ['StatusCounter'] as const,
  endpoints: (builder) => ({
    getStatusCounter: builder.query<StatusCounterItem[], void>({
      query: () => ({
        url: '/status-counter',
      }),
      providesTags: ['StatusCounter'],
    }),
  }),
});

export const { useGetStatusCounterQuery } = fleetDashboardService;
export default fleetDashboardService;
